export const ProjectHeaderMinimizedHeight = "46px";
export const ProjectHeaderMinimizedTopMargin = "88px";
export const RecTabHeaderMinimizedHeight = "44px";
export const RecStickyHeaderMinimizedHeight = "90px"; // ProjectHeaderMinimizedHeight + RecTabHeaderMinimizedHeight
